module.exports = __webpack_public_path__ + "static/media/tpn-events-v1.01390501.png";